import {
  IP
} from "@/services/config.js";
import axios from "axios";
import Vue from "vue";
const {
  aesEncrypt,
  aesDecrypt
} = require("@/utils/crypter/aes/index");
const {
  rsaEncrypt,
  rsaDecrypt
} = require("@/utils/crypter/rsa/index");
const {
  randomNumber
} = require("@/utils/tool");
export const token = "";
// import { RSA } from "./crypter/rsa";
// import { AES } from "./crypter/aes";
// import { DEFAULT_PUB_KEY } from "./crypter/rsa/conf";

const isAllEncrypt = false; //是否开启全局加密（全局关闭，统一走明文）
const isAllDecrypt = false; //是否开启全局解密（全局关闭，统一走明文）

// const isAllEncrypt = false; //是否开启全局加密
// const isAllDecrypt = false; //是否开启全局解密

let baseURL = IP;
// const service = axios.create({
//     baseURL,
//     timeout:30000
// });
// console.log(DEFAULT_PUB_KEY);
export let request = axios.create({
  baseURL,
  timeout: 700000,
});

// 额外提供一个明文请求实例：不加密请求体，不解密响应体
export let requestPlain = axios.create({
  baseURL,
  timeout: 700000,
});
/**
 * 使用说明：
 * - 加密请求（默认）：request({ url: '/path', method: 'POST', data: {...} })
 * - 明文请求：request({ url: '/path', method: 'POST', isEncrypt: false, isDecrypt: false, data: {...} })
 *   或者使用 requestPlain({ url: '/path', method: 'POST', data: {...} })
 */
/**
 * request
 * 请求拦截器
 */
request.interceptors.request.use(
  async ({
      isEncrypt = true, // 业务可通过 isEncrypt=false 发送明文
      ...config
    }) => {
      // 配置请求头
      // config.headers["Authorization"] = JSON.parse(
      //   localStorage.getItem("storeToken")
      // )?.storeToken;
      // config.headers["Authorization"] = token;
      // let data = config.data;
      log({
        type: "request",
        url: config.url,
        data: config.data,
      })
      config.headers["X-Access-Token"] = localStorage.getItem("storeToken");
      const tenantId = localStorage.getItem("loginTenantId");
      if (tenantId) {
        config.headers["X-Tenant-Id"] = tenantId;
      }
      if (isAllEncrypt && isEncrypt) {
        const SECRET_KEY = randomNumber(16);
        config.data = {
          key: await rsaEncrypt(SECRET_KEY),
          data: await aesEncrypt({
            data: config.data,
            SECRET_KEY,
          }),
        };
      }
      return config;
    },
    (error) => {
      console.error(error);
    }
);

// 明文实例请求拦截器：强制明文
requestPlain.interceptors.request.use(
  async ({
      ...config
    }) => {
      log({
        type: "request",
        url: config.url,
        data: config.data,
      })
      config.headers["X-Access-Token"] = localStorage.getItem("storeToken");
      const tenantId = localStorage.getItem("loginTenantId");
      if (tenantId) {
        config.headers["X-Tenant-Id"] = tenantId;
      }
      return config;
    },
    (error) => {
      console.error(error);
    }
);

/**
 * 响应拦截器
 */
request.interceptors.response.use(
  async ({
      data,
      config,
      status
    }) => {
      const {
        isDecrypt = true
      } = config;
      if (status !== 200) {
        console.error("网络错误");
        errorMessage({
          message: '网络错误'
        })
        return;
      }
      // 自动识别密文：仅当数据结构包含 key 与 data 时尝试解密
      if (isAllDecrypt && isDecrypt && data && typeof data === 'object' && 'key' in data && 'data' in data) {
        try {
          const SECRET_KEY = await rsaDecrypt(data.key);
          data = await aesDecrypt({
            data: data.data,
            SECRET_KEY,
          });
        } catch (e) {
          // 解密失败则按明文处理
        }
      }
      log({
        type: "response",
        url: config.url,
        data,
      })
      if (data.code !== 200) {
        errorMessage({
          message: data.message || '网络错误'
        })
      }
      return data;
    },
    (error) => {
      //处理是否为token过去 跳转到登录页
      console.log("error:", error);
      errorMessage({
        message: error || '网络错误'
      })
    }
);

// 明文实例响应拦截器：不做解密
requestPlain.interceptors.response.use(
  async ({
      data,
      config,
      status
    }) => {
      if (status !== 200) {
        console.error("网络错误");
        errorMessage({
          message: '网络错误'
        })
        return;
      }
      log({
        type: "response",
        url: config.url,
        data,
      })
      if (data && data.code !== undefined && data.code !== 200) {
        errorMessage({
          message: data.message || '网络错误'
        })
      }
      return data;
    },
    (error) => {
      console.log("error:", error);
      errorMessage({
        message: error || '网络错误'
      })
    }
);


/* 请求错误处理error */
function errorMessage({
  message
}) {
  Vue.prototype.$message.error(message)
  const loading = document.querySelector('.is-fullscreen')
  if (loading) {
    loading.style.display = 'none';
  }
}

/**
 * 打印日志
 * type：日志类型 request/response
 */
function log({
  type,
  url,
  data
}) {
  //请求日志(测试环境打印，线上不打印)
  if (process.env.NODE_ENV === "development") {
    console.log(type, url, ":", data);
  }
}
